import { createLogger, LogLevel } from "~mangomap-ui/lib/logger";

export const logger = createLogger({ level: LogLevel.ALL });
